import { useProfile } from "../context/ProfileContext";
import { ArrowUpRight, Newspaper } from "lucide-react";

export default function Press() {
  const PROFILE = useProfile();
  return (
    <section
      id="press"
      className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-white/10"
      data-testid="press-section"
    >
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-4">
              06 — In the News
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-white leading-none">
              <Newspaper
                size={42}
                className="inline-block mb-2 mr-3 text-[#E60000]"
                strokeWidth={1.5}
              />
              Press & Mentions
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {PROFILE.press.map((p, i) => (
            <a
              key={p.url}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group border border-white/10 p-8 lg:p-10 hover:bg-[#111111] hover:border-[#E60000] transition-all flex flex-col gap-6 min-h-[280px]"
              data-testid={`press-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold">
                  {p.outlet}
                </span>
                <span className="text-[10px] tracking-[0.2em] uppercase text-[#8A8A8A]">
                  {p.date}
                </span>
              </div>
              <h3 className="font-display text-2xl sm:text-3xl uppercase font-bold tracking-tight text-white leading-tight flex-1">
                {p.title}
              </h3>
              <div className="flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-white pt-4 border-t border-white/10">
                Read Article
                <ArrowUpRight
                  size={14}
                  className="group-hover:rotate-45 transition-transform"
                  strokeWidth={2.5}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
